import { Control } from "ol/control";
import { Style } from "ol/style";

var HistoryControl = (function (Control) {
  function HistoryControl(opt_options) {
    var options = opt_options || {};

    var button = document.createElement("button");
    button.innerHTML = "R";
    button.title = "Réinitialisation";

    var element = document.createElement("div");
    element.className = "history-control ol-unselectable ol-control";
    element.appendChild(button);

    Control.call(this, {
      element: element,
      target: options.target,
    });

    function reInit() {
      var view = this.getMap().getView();
      view.setRotation(0);

      if (typeof options.callback === "function") {
        options.callback(options.center);
      }
    }

    button.addEventListener("click", reInit.bind(this), false);
  }

  if (Control) HistoryControl.__proto__ = Control;
  HistoryControl.prototype = Object.create(Control && Control.prototype);
  HistoryControl.prototype.constructor = HistoryControl;

  return HistoryControl;
})(Control);

function featureVisible(feature, visible) {
  //!feature.get("hidden")
  if (!visible) {
    feature.setStyle(new Style({}));
    feature.set("hidden", true);
  } else {
    feature.setStyle();
    feature.unset("hidden");
  }
}

export { HistoryControl, featureVisible };
